import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Alert } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import PageTitle from '../../../layouts/PageTitle';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { useLoader } from '../../../../context/LoaderCotext';
import Swal from 'sweetalert2';
import { createFormAction } from '../../../../store/actions/FormsActions';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import ProjectCodesServices from '../../../../services/ProjectCodeService';
import { getMTEByEmail } from '../../../../services/MTEService';
import Select from 'react-select';
import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import moment from 'moment';
const CriticalFlexTimeForm = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { showLoader, hideLoader } = useLoader();
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [projectCodeList, setProjectCodeList] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const { hasPermission } = useAuth();

  // Helper to strip time part
  const stripTime = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const today = stripTime(new Date());

  // Validation Schema
  const validationSchema = Yup.object().shape({
    employee: Yup.object().required('Employee is required'),
    employeeNumber: Yup.string().required('Employee number is required'),
    employeeManager: Yup.string(),
    contract: Yup.string(),
    date: Yup.date().required('Date is required'),
    projects: Yup.string().required('Projects are required'),
    startDate: Yup.string().required('Start date is required'),
    endDate: Yup.string().required('End date is required'),
    maxAdditionalHours: Yup.number()
      .required('Maximum additional hours is required')
      .positive('Must be a positive number')
      .integer('Must be a whole number'),
    justification: Yup.string().required('Justification is required'),
  });

  const [initialValues, setInitialValues] = useState({
    employee: '',
    employeeNumber: '',
    employeeManager: '',
    contract: '',
    date: new Date(),
    projects: '',
    startDate: '',
    endDate: '',
    maxAdditionalHours: '',
    justification: '',
    boxFolderId: '275393000439',
    boxFolderName: 'mcft-forms',
    timestamp: moment().unix(),
    customerApproved: false,
  });

  // Fetch employees on component mount
  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  useEffect(() => {
    setFolderAPISuccess(true);
  }, [cookieValue]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const handleEmployeeChange = async (selectedOption, setFieldValue, values) => {
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`employeeManager`, '');
      setFieldValue(`contract`, '');
      return false;
    }

    const getManager = await getMTEByEmail(selectedOption.email);
    if (
      typeof getManager != 'undefined' &&
      typeof getManager.manager != 'undefined' &&
      typeof getManager.contract != 'undefined' &&
      getManager.contract != '' &&
      getManager.contract.toLowerCase() != profile.contract.toLowerCase() &&
      profile.role.toLowerCase() !== 'admin'
    ) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'You are not accosiated with selected employee contract, please select correct employee and contract',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`employeeManager`, '');
      setFieldValue(`contract`, '');
      return false;
    }
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`employeeManager`, getManager.manager || '');
    setFieldValue(`contract`, getManager.contract || '');
    ProjectCodesServices.getProjectCode(selectedOption.employeeNumber || '')
      .then((response) => {
        // Ensure response and data exist and are valid
        if (!response || !Array.isArray(response.data) || response.data.length === 0) {
          console.log('Invalid or empty project code data');
          setProjectCodeList([]);
          return; // Early return if no valid data
        }

        // Flatten and map project codes, with additional checks
        const codeList = response.data.flatMap(({ projectCodes }) =>
          Array.isArray(projectCodes) && projectCodes.length > 0
            ? projectCodes.map((code) => ({
                value: code,
                label: code,
              }))
            : []
        );

        // Update state with the final list of project codes, only if codeList is not empty
        if (codeList.length > 0) {
          setProjectCodeList(codeList);
        } else {
          console.log('No valid project codes found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching project codes:', error);
      });
  };
  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }

    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
          manager: employee.manager,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'mcft-forms',
      contractor: 'ssai',
      dynamicFields: [
        {
          submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
          ...data,
        },
      ],
    };

    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });

          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        employee: data.employee.value,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
      };
      handleUploadBatch(payloadForms);
    }
  };

  // Add at the top of the component before return
  const payPeriods = [
  { label: '01/01/26 - 01/15/26 - Pay Period 1', value: '2026-01-01' },
  { label: '01/16/26 - 01/31/26 - Pay Period 2', value: '2026-01-16' },
  { label: '02/01/26 - 02/15/26 - Pay Period 3', value: '2026-02-01' },
  { label: '02/16/26 - 02/28/26 - Pay Period 4', value: '2026-02-16' },
  { label: '03/01/26 - 03/15/26 - Pay Period 5', value: '2026-03-01' },
  { label: '03/16/26 - 03/31/26 - Pay Period 6', value: '2026-03-16' },
  { label: '04/01/26 - 04/15/26 - Pay Period 7', value: '2026-04-01' },
  { label: '04/16/26 - 04/30/26 - Pay Period 8', value: '2026-04-16' },
  { label: '05/01/26 - 05/15/26 - Pay Period 9', value: '2026-05-01' },
  { label: '05/16/26 - 05/31/26 - Pay Period 10', value: '2026-05-16' },
  { label: '06/01/26 - 06/15/26 - Pay Period 11', value: '2026-06-01' },
  { label: '06/16/26 - 06/30/26 - Pay Period 12', value: '2026-06-16' },
  { label: '07/01/26 - 07/15/26 - Pay Period 13', value: '2026-07-01' },
  { label: '07/16/26 - 07/31/26 - Pay Period 14', value: '2026-07-16' },
  { label: '08/01/26 - 08/15/26 - Pay Period 15', value: '2026-08-01' },
  { label: '08/16/26 - 08/31/26 - Pay Period 16', value: '2026-08-16' },
  { label: '09/01/26 - 09/15/26 - Pay Period 17', value: '2026-09-01' },
  { label: '09/16/26 - 09/30/26 - Pay Period 18', value: '2026-09-16' },
  { label: '10/01/26 - 10/15/26 - Pay Period 19', value: '2026-10-01' },
  { label: '10/16/26 - 10/31/26 - Pay Period 20', value: '2026-10-16' },
  { label: '11/01/26 - 11/15/26 - Pay Period 21', value: '2026-11-01' },
  { label: '11/16/26 - 11/30/26 - Pay Period 22', value: '2026-11-16' },
  { label: '12/01/26 - 12/15/26 - Pay Period 23', value: '2026-12-01' },
  { label: '12/16/26 - 12/31/26 - Pay Period 24', value: '2026-12-16' },
];
  // Helper to get next 3 periods + current
  const getEndDateOptions = (startLabel) => {
    const startIndex = payPeriods.findIndex((p) => p.label === startLabel);
    if (startIndex === -1) return [];
    return payPeriods.slice(startIndex, startIndex + 4); // current + next 3
  };

  return (
    <>
      <PageTitle pageTitle="Mission Critical FlexTime Request Form" />
      <Card>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', paddingBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1964977689043"
          >
            Instruction to Submit the MCFT Form
          </Link>
        </div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting, errors, touched }) => (
            <FormikForm>
              {/* First row with 3 columns */}
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Employee Name <span className="text-danger">*</span>
                    </Form.Label>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={employeeList}
                      loadOptions={loadOptions}
                      placeholder="Search employee..."
                      onChange={(option) => {
                        setFieldValue('employee', option);
                        handleEmployeeChange(option, setFieldValue, values);
                      }}
                      value={values.employee}
                    />
                    <ErrorMessage name="employee" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Employee Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      as={Form.Control}
                      name="employeeNumber"
                      type="text"
                      readOnly
                      value={values.employeeNumber || ''}
                      placeholder="Employee Number"
                    />
                    <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Employee Manager</Form.Label>
                    <Field
                      as={Form.Control}
                      name="employeeManager"
                      type="text"
                      readOnly
                      value={values.employeeManager}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Second row */}
              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Date <span className="text-danger">*</span>
                    </Form.Label>
                    <DatePicker
                      selected={values.date}
                      onChange={(date) => setFieldValue('date', date)}
                      className="form-control"
                      minDate={new Date()}
                      readOnly
                    />
                    <ErrorMessage name="date" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Projects <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      name="projects"
                      options={projectCodeList}
                      value={
                        projectCodeList.find((option) => option.value === values.projects) || null
                      }
                      onChange={(selectedOption) => {
                        setFieldValue('projects', selectedOption ? selectedOption.value : '');
                      }}
                      placeholder="Select project code"
                    />
                    <ErrorMessage name="projects" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Contract</Form.Label>
                    <Field
                      as={Form.Control}
                      name="contract"
                      type="text"
                      readOnly
                      value={values.contract}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Third row */}
              <Row className="mb-3">
                <Col md={5}>
                  <Form.Group>
                    <Form.Label>
                      Pay Period Start Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={payPeriods}
                      value={payPeriods.find((p) => p.label === values.startDate) || null}
                      onChange={(selected) => {
                        setFieldValue('startDate', selected.label);
                        // Reset end date when start date changes
                        setFieldValue('endDate', '');
                      }}
                      placeholder="Select pay period start date"
                    />
                    <ErrorMessage name="startDate" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={5}>
                  <Form.Group>
                    <Form.Label>
                      Pay Period End Date <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                      options={getEndDateOptions(values.startDate)}
                      value={
                        getEndDateOptions(values.startDate).find(
                          (p) => p.label === values.endDate
                        ) || null
                      }
                      onChange={(selected) => setFieldValue('endDate', selected.label)}
                      placeholder="Select pay period end date"
                      isDisabled={!values.startDate}
                    />
                    <ErrorMessage name="endDate" component="div" className="text-danger" />
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group>
                    <Form.Label>
                      Max Additional Hours <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      as={Form.Control}
                      name="maxAdditionalHours"
                      type="number"
                      min="1"
                      value={values.maxAdditionalHours}
                      onChange={(e) => setFieldValue('maxAdditionalHours', e.target.value)}
                    />
                    <ErrorMessage
                      name="maxAdditionalHours"
                      component="div"
                      className="text-danger"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  {/* Justification */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Justification/Reason(s) <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      as="textarea"
                      name="justification"
                      className="form-control"
                      rows={3}
                      placeholder="Explain why this critical flextime is needed"
                    />
                    <ErrorMessage name="justification" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
                <Col style={{ paddingTop: '50px' }}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ marginRight: '20px' }}>Customer Approved?</Form.Label>
                    <Field
                      type="checkbox"
                      name="customerApproved"
                      value="yes"
                      className="form-check-input me-2"
                      label="Customer Approved"
                      checked={values.customerApproved == true || values.customerApproved == 'true'}
                      onChange={(e) => setFieldValue('customerApproved', e.target.checked)}
                    />

                    <ErrorMessage name="customerApproved" component="div" className="text-danger" />
                  </Form.Group>
                </Col>
              </Row>
              <div className="mt-3 mb-4">
                <p className="text-muted">
                  <strong>Note:</strong> Employee is projected to work over normal hours
                </p>
              </div>
              <Button variant="primary" type="submit">
                Submit Request
              </Button>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(CriticalFlexTimeForm);
